jQuery_T4NT(document).ready(function ($) {
  /**
   *  Variant selection changed
   *  data-variant-toggle="{{variant.id}}"
   */
  $(document).on("variant:changed", function (evt) {
    // console.log( evt.currentVariant );
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  });
});

// Cache the HTML element for repeated use
const html = document.documentElement;

// Function to manage the header's transparency and stuck state based on scroll position
// This function will be used only on 'https://www.pureelectric.com'
function checkScrollPositionForTransparency() {
    if (window.location.href !== 'https://www.pureelectric.com/') return;

    const atTop = window.pageYOffset === 0;
    if (atTop) {
        html.classList.add('is--header-transparent');
        html.classList.remove('is-stuck', 'is-header--stuck');
    } else {
        html.classList.remove('is--header-transparent');
        html.classList.remove('is-header--stuck'); // Ensure this is removed if not at the top
    }
}

// Function to handle the reveal logic
function reveal() {
    const header = document.querySelector('header'); // Assuming the header has a tag of <header>
    if (!header) return; // Early return if header not found

    // Dispatching a custom event named 'T4sHeaderReveal'
    header.dispatchEvent(new Event('T4sHeaderReveal'));

    // Only add 'is-stuck' class when not at the top
    if (window.pageYOffset !== 0) {
        html.classList.add('is-stuck', 'is-header--stuck');
        header.classList.add('shopify-section-header-sticky', 'animate');
        header.classList.remove('shopify-section-header-hidden');
    }
}

let scrollTimeoutId;
// Add scroll event listener
window.addEventListener('scroll', () => {
    // Function specific to 'https://www.pureelectric.com'
    checkScrollPositionForTransparency();

    // Clear the timeout if it's set
    clearTimeout(scrollTimeoutId);

    // Reset timeout every time the user scrolls
    scrollTimeoutId = setTimeout(reveal, 150); // 150 milliseconds delay to determine scroll stop
});

// Initial check specific to 'https://www.pureelectric.com'
checkScrollPositionForTransparency();

var _fo=_fo?_fo:[];_fo.push({'c':'igfhd','i':'bpnjuus','m':0,'s':0,'w':540,'t':'rgba(251, 56, 251, 1)'}); if (typeof fce=='undefined') {var s=document.createElement('script');s.type='text/javascript'; s.async=true; s.src='https://formcrafts.com/js/fc.js'; document.body.appendChild(s);fce=1;}